import { all, fork } from "redux-saga/effects"

//public
import AuthSaga from "./auth/login/saga"
import LayoutSaga from "./layout/saga"
import dashboardSaga from "./dashboard/saga"
import orderSaga from "./orderManagement/saga"
import resolvedTsaga from "./dbInvoices/sagas"
import serviceSaga from "./servicesManagment/sagas"
import cardSaga from "./card/cartAbandonmentSaga"
import invoicesSaga from "./invoices/invoicesSaga"
import { watchCancellationsSaga } from "./cancellations/saga"
import customerSettlementsSaga from "./customerSettlements/sagas"
import providerErpInvoicesSaga from "./providerErpInvoices/saga"
import maintenanceSaga from "./maintenance/saga"

export default function* rootSaga() {
  yield all([
    //public
    fork(cardSaga),
    fork(AuthSaga),
    fork(LayoutSaga),
    fork(dashboardSaga),
    fork(resolvedTsaga),
    fork(orderSaga),
    fork(serviceSaga),
    fork(invoicesSaga),
    fork(watchCancellationsSaga),
    fork(customerSettlementsSaga),
    fork(providerErpInvoicesSaga),
    fork(maintenanceSaga)
  ])
}
